import { PageModel, PageStatus } from "../../../shared/model/page-model";
import { updatePageModelReducer } from "../../../shared/model/page-model-reduers";
import { YOU_WILL_RECEIVE_AN_EMAIL_MESSAGE, TWENTY_FOUR_HOURS_MESSAGE } from "../../../helpers/constants";

export function updatePageModelForStatusChangeReducer(pageModel: PageModel, pageStatus: PageStatus): PageModel {
  let { title, informationMessages, buttonTitle, showButton, showFooter } = pageModel;
  switch (pageStatus) {
    case "Ready":
      title = "Forgotten Password";
      informationMessages = [
        "Enter your Email below and we will send a message to reset your password."
      ];
      buttonTitle = "Reset my password";
      showButton = true;
      showFooter = true;
      break;
    case "Sending":
      title = "Please wait";
      informationMessages = ["Sending details to confirm account"];
      buttonTitle = "Sending";
      showButton = true;
      showFooter = true;
      break;
    case "Succeeded":
      title = "Request received";
      informationMessages = [
        YOU_WILL_RECEIVE_AN_EMAIL_MESSAGE,
        TWENTY_FOUR_HOURS_MESSAGE
      ];
      buttonTitle = "";
      showButton = false;
      showFooter = true;
      break;
    case "Missing Query Parameters":
      title = "Not Authorised";
      buttonTitle = "";
      informationMessages = ["Unable to determine client application."];
      showButton = false;
      showFooter = false;
      break;
    case "Failed":
      // see forgot-password-response-code-helper for failure messages
      buttonTitle = "Retry";
      showButton = true;
      showFooter = true;
      break;
  }
  return updatePageModelReducer(pageModel, {
    title,
    informationMessages,
    buttonTitle,
    showButton,
    showFooter
  });
}
